import type { IGlobalTab } from '@carboncopyco/types/desktop';
import { Loader as AppLoader } from '@carboncopyco/ui';
import { MemoryRouter, Route, Routes } from 'react-router-dom';
import InnerTabsContainer from '../components/InnerTabs/InnerTabsContainer';
import InnerViewArea from '../components/InnerViewArea';
import { isActiveOrAllInnerTabsLoaded } from '../shared/utils';
import { ResponsiveModeContextProvider } from '../store/context/ResponsiveModeContext';
import { UpdateRecordingPage } from './UpdateRecordingPage';

const UpdateCloneRoute = ({ tab }: { tab: IGlobalTab }) => (
  <ResponsiveModeContextProvider>
    <div className="flex flex-col flex-grow flex-shrink-0 basis-auto">
      <UpdateRecordingPage />
      <InnerTabsContainer globalTab={tab} />
      <div className="flex grow relative">
        <InnerViewArea tab={tab} />
        {!isActiveOrAllInnerTabsLoaded(tab) && <AppLoader show />}
      </div>
    </div>
  </ResponsiveModeContextProvider>
);

const UpdateCloneScreen = ({ tab }: { tab: IGlobalTab }) => (
  <MemoryRouter>
    <Routes>
      <Route
        path="/*"
        element={<UpdateCloneRoute tab={tab} />}
      />
    </Routes>
  </MemoryRouter>
);

export default UpdateCloneScreen;
